export enum TransactionType {
  EXPENSE = 'expense',
  INCOME = 'income',
  TRANSFER = 'transfer'
}

export interface Transaction {
  transaction_id: number;
  amount: number;
  date: string;
  description: string;
  account_id: string;
  account_name: string;
  merchant_name?: string;
  category_name: string;
  header_name?: string;
  header_id?: string;
  category_id?: string;
  notes?: string;
  pending: boolean;
  recurring: boolean;
  recurring_frequency?: number;
  payment_channel?: string;
  location?: Record<string, any>;
  iso_currency_code?: string;
  transaction_type: TransactionType;
  transfer_account?: string;
  plaid_transaction_id?: string;
  group_expense_id?: number;
}

export interface TransactionFormData {
  transaction_id?: number;
  amount: number;
  date: Date;
  description: string;
  account_id: string;
  account_name?: string;
  header_id?: string;
  header_name?: string;
  category_id?: string;
  category_name?: string;
  merchant_name?: string;
  notes?: string;
  recurring?: boolean;
  recurring_frequency?: number;
  payment_channel?: string;
  location?: Record<string, any>;
  iso_currency_code?: string;
  transaction_type: TransactionType;
  transfer_account?: string;
  location_manual_input?: string;
}

// Add this new interface for the paginated response
export interface PaginatedTransactionResponse {
  items: Transaction[];
  total: number;
  page: number;
  size: number;
  pages: number;
  // fastapi-pagination also includes next/prev links by default, but we might not need them if we calculate page numbers
  // next?: string | null;
  // previous?: string | null;
} 